import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppConfig } from '@app/app.config';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'zone.js';

if (environment.production) {
	enableProdMode();
}

/**
 * nome unico del file di configurazione
 * @see angular.json build configurations
 * @since 17.6.0
 */
const CONFIG_FILENAME = 'config';

fetch(`./config/${CONFIG_FILENAME}.json?x=${new Date().getTime()}`)
	.then(response => response.json())
	.then(data => AppConfig.extend(data))
	.then(data => {
		platformBrowserDynamic()
			.bootstrapModule(AppModule(data))
			.catch(err => console.error(err));
	});
